import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const RevokeApprovalCallbackContext = /*#__PURE__*/createContext(undefined);
export function RevokeApprovalCallbackProvider({
  onRevokeApproval,
  children
}) {
  return /*#__PURE__*/_jsx(RevokeApprovalCallbackContext.Provider, {
    value: {
      onRevokeApproval
    },
    children: children
  });
}
export function useRevokeApprovalCallback() {
  const context = useContext(RevokeApprovalCallbackContext);
  if (context === undefined) {
    throw new Error('useRevokeApprovalCallback must be used within an RevokeApprovalCallbackProvider');
  }
  return context;
}